import { useBranding } from '../../context/BrandingContext';
import { APP_VERSION } from '../../config/version';

const Footer = () => {
  const { branding } = useBranding();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="fixed bottom-0 left-0 right-0 z-40 bg-slate-900 border-t border-slate-700/50">
      <div className="max-w-screen-2xl mx-auto px-4 py-2">
        <div className="flex items-center justify-between text-xs text-slate-400">
          <div className="flex items-center gap-2">
            <span>© {currentYear} {branding.company_name}</span>
          </div>
          <div className="flex items-center gap-3">
            <span className="text-slate-500">{branding.footer_text}</span>
            <span className="text-slate-600">|</span>
            <span className="text-primary/70 font-mono">v{APP_VERSION}</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
